module.exports = __webpack_public_path__ + "public/images/executive.446bbc080b1d640817f66f05aa23bf0c.webp";